import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { SegmentedSpinnerModule } from '@libs/src/segmented-spinner/segmented-spinner.module';

import { ProfileCompletionWidgetComponent } from '@main-client/src/app/profile-completion-widget/profile-completion-widget.component';

@NgModule({
  declarations: [ProfileCompletionWidgetComponent],
  exports: [ProfileCompletionWidgetComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    SegmentedSpinnerModule,
  ],
})
export class ProfileCompletionWidgetModule {}
